<template>
  <div class="loading-container">
    <el-icon :size="36" class="loading">
      <Loading />
    </el-icon>
    <span>正在加载...</span>
  </div>
</template>

<script lang="ts" setup>
import { ElIcon } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'
</script>

<style lang="less" scoped>
.loading {
  animation: rotating 2s linear infinite;
  margin-bottom: 10px;
}
.loading-container {
  z-index: 99;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #335dfd;
}
</style>
